export default {
  // 登陆鉴权，获取aid和token
  LOGIN: '/v1/interface/inner/cloudim_324034',
  // 退出排队
  EXIT_QUEUE: '/v1/interface/inner/txplus_214001',
  // 下载被压缩的长文本或xml
  DOWNLOAD_COMPRESSED_COTENT: '/interface/inner/cloudcc_303902',
  // 添加到客户库。
  ADD_TO_CUST_BASE: '/v1/websdk/inner/txplus_100016',
  // 查询消息已读未读信息
  GET_MSG_READ_INFO_REQ: '/v1/customerService/message/c/getMsgReadInfoReq',
  // 上报消息已读未读信息
  REPORT_MSG_READ_INFO: '/v1/customerService/message/c/reportMsgReadInfo',
}